export default function strBoolean(val) {
    return val === 'true' ? true : false;
}
